import React from 'react';

import { ReactActionDialogBodyProps } from '~commonInfra/dialogs/ReactActionDialog';
import { EditPoolNameField } from '~src/settings/bridge-settings/sections/bridgeMultiPool/EditPoolNameField';

export type PropsForEditBridgePoolDialog = ReactActionDialogBodyProps<
  EditBridgePoolDialogProps,
  EditBridgePoolDialogState
>;

export type EditBridgePoolDialogProps = Readonly<{
  existingPoolNames: string[];
}>

export type EditBridgePoolDialogState = Readonly<{
  poolName: string;
  hasError: boolean;
}>

export function EditBridgePoolDialogBody(props: PropsForEditBridgePoolDialog) {
  const onPoolNameChange = (poolName: string) => {
    props.updateDialogState({ poolName });
  };
  const onHasErrorChange = (hasError: boolean) => {
    props.updateDialogState({ hasError });
  };

  return (
    <EditPoolNameField
      poolName={props.dialogState.poolName}
      onPoolNameChange={onPoolNameChange}
      hasError={props.dialogState.hasError}
      onHasErrorChange={onHasErrorChange}
      existingPoolNames={props.existingPoolNames}
    />
  );
}
